import {Button, Dialog, DialogBody, DialogFooter, DialogHeader, Typography} from "@material-tailwind/react";
import React, {useContext, useState} from "react";
import "../../style/datePicker.css"
import SelectInput from "../system/select";
import {getServiceAgentBranchFees} from "../../services/agent_branch_fee/agent_branch_fee";
import {submitService} from "../../services/service/service";
import {ServiceContext} from "./service_context";

export function ServiceRequestForm({agentId}) {

  const {modalOpen, setModalOpen, setLastDataRefresh, setService, setStep} = useContext(ServiceContext);

  const handleOpen = () => setModalOpen(!modalOpen);

  // const [agentId, setAgentId] = useState(null)
  const [branchId, setBranchId] = useState(null)

  const save = async () => {
    const data = {
      agent_id: agentId,
      branch_id: branchId,
    };
    let result;

    result = await submitService(data);

    setService(result.data.person_service)

    if (result.status === 201) {
      setLastDataRefresh(Date.now())
      // setStep("check")
      handleOpen()
    }
  };

  return (
    <>
      <Dialog open={modalOpen} handler={handleOpen} animate={{mount: {scale: 1, y: 0}, unmount: {scale: 0.9, y: -100}}}>
        <DialogHeader className="border-b">
          <Typography>ثبت درخواست استعلام قیمت</Typography>
        </DialogHeader>
        <DialogBody className="flex flex-col gap-4 overflow-y-visible">

          {agentId &&
            <div className="mb-4">
              <SelectInput
                label={"رشته - گرایش"}
                defaultValue={branchId}
                refreshSignal={agentId}
                autoLoadServiceData={agentId}
                multiselect={false}
                autoLoadService={getServiceAgentBranchFees}
                autoLoadRender={({field_title, branch_title}) => {
                  return field_title + " - " + branch_title
                }}
                onChange={setBranchId}
              />
            </div>
          }

        </DialogBody>
        <DialogFooter className="space-x-2">
          <Button variant="text" color="gray" onClick={handleOpen}>
            <span>انصراف</span>
          </Button>
          <Button variant="gradient" color="gray" onClick={save} className="ml-1">
            <span>ثبت درخواست</span>
          </Button>

        </DialogFooter>
      </Dialog>
    </>
  );
}